import React from 'react';

import { View, Log, Logs, LogComment, LogText } from '@gogame/components';

import { useLoadSALogs } from 'scenes/SpendAdjustments/data';

import { ERROR } from './constants';
import { getColor } from './utils';

const ActionsLog = ({ id }) => {
  const { data, isLoading, isRefetching } = useLoadSALogs(id);

  return (
    <View loading={isLoading} fetching={isRefetching}>
      {data ? (
        <Logs empty={!data.length}>
          {data.map((log, id) => {
            return (
              <Log key={id} color={getColor(log.status?.id)}>
                <LogText
                  status={log.status?.name}
                  action={log.action}
                  user={log.user}
                  date={log.date}
                  error={log.status?.id === ERROR}
                >
                  {log.comment && <LogComment>{log.comment}</LogComment>}
                </LogText>
              </Log>
            );
          })}
        </Logs>
      ) : null}
    </View>
  );
};

export default ActionsLog;
